import React from 'react'

import { useIsMobile } from '@/app/hooks/use-is-mobile'
import { Balance, Organization, SelectOption } from '@/app/types'

import DesktopHeader from './desktop-header'
import MobileHeader from './mobile-header'

type Props = {
  activeOrg?: Organization
  balance?: Balance
  currentPage: string
  email: string
  token: string
  organizations?: SelectOption<number>[]

  logout?: () => void
  switchOrganization: (args: {
    token: string
    item: {
      label: string
      value: number
    }
  }) => Promise<void>
}

const Header: React.FC<Props> = (props) => {
  const {
    activeOrg,
    token,
    balance,
    currentPage,
    email,
    organizations = [],
    logout = () => {},
    switchOrganization,
  } = props

  const isMobile = useIsMobile()

  const [accountMenuOpen, setAccountMenuOpen] = React.useState(false)
  const [mobileMenuOpen, setMobileMenuOpen] = React.useState(false)
  const [orgListExpanded, setOrgListExpanded] = React.useState(false)

  const isAuthorized = !!token
  const hasOrg = isAuthorized && !!activeOrg

  const toggleAccountMenu = React.useCallback(() => {
    setAccountMenuOpen((prev) => !prev)
    setOrgListExpanded(false)
  }, [])

  const toggleMobileNav = React.useCallback(() => {
    setMobileMenuOpen((prev) => !prev)
  }, [])

  const togglePanelExpand = React.useCallback(() => {
    setOrgListExpanded((prev) => !prev)
  }, [])

  const handleSwitchOrganization = React.useCallback(
    ({ label, value }: SelectOption<number>) => {
      switchOrganization({ token, item: { label, value } }).then(() => {
        // hacky. Need to wait on all other updates.
        setTimeout(() => {
          window.location.reload()
        }, 500)
      })
    },
    [token, switchOrganization],
  )

  if (isMobile) {
    return (
      <MobileHeader
        activeOrg={activeOrg}
        balance={balance}
        currentPage={currentPage}
        email={email}
        organizations={organizations}
        isAuthorized={isAuthorized}
        hasOrg={hasOrg}
        mobileMenuOpen={mobileMenuOpen}
        logout={logout}
        onOrgSelect={handleSwitchOrganization}
        onToggleMobileNav={toggleMobileNav}
      />
    )
  }

  return (
    <DesktopHeader
      activeOrg={activeOrg}
      balance={balance}
      currentPage={currentPage}
      email={email}
      organizations={organizations}
      isAuthorized={isAuthorized}
      hasOrg={hasOrg}
      accountMenuOpen={accountMenuOpen}
      orgListExpanded={orgListExpanded}
      logout={logout}
      onAccountMenuToggle={toggleAccountMenu}
      onOrgSelect={handleSwitchOrganization}
      onPanelToggle={togglePanelExpand}
    />
  )
}

export default Header
